import { render, staticRenderFns } from "./LaporanPemilikSistem.vue?vue&type=template&id=b57c3946&scoped=true&"
import script from "./LaporanPemilikSistem.vue?vue&type=script&lang=js&"
export * from "./LaporanPemilikSistem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57c3946",
  null
  
)

export default component.exports